import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Persona } from '../models/persona';
import {map, catchError} from 'rxjs/operators';
import swal from 'sweetalert2';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PersonaService {

  //private baseEndPoint='https://cnsfdesmic3.cnsf.gob.mx/zuulO2/cnsf/constancia'; //>>>>DESARROLLOv2
  //private urlTOken = 'https://cnsfdesmic3.cnsf.gob.mx/zuulO2/cnsf/api/security/oauth/token'; //>>>>DESARROLLO

  //private baseEndPoint='http://cnsfdesmic3:9009/cnsf/constancia';
  //private urlTOken = 'http://cnsfdesmic3:9009/cnsf/api/security/oauth/token'; //>>>>DESARROLLO

  //private baseEndPoint='https://constanciadigitaldrp.cnsf.gob.mx/zuulO2/cnsf/constancia';
  //private urlTOken = 'https://constanciadigitaldrp.cnsf.gob.mx/zuulO2/cnsf/api/security/oauth/token'; //>>>>DRP

  private baseEndPoint='https://constanciadigital.cnsf.gob.mx/zuulO2/cnsf/constancia';
  private urlTOken = 'https://constanciadigital.cnsf.gob.mx/zuulO2/cnsf/api/security/oauth/token'; //>>>>PRODUCCION

  //private baseEndPoint='http://cnsfmicserp:10025';
  //private urlTOken = 'http://cnsfmicserp:10025/token'

  //private baseEndPoint='http://localhost:10025';
  //private urlTOken = 'http://cnsfmicserp:10025/token'; //>>>>DESARROLLO
  
  private httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  httpHeadersToken = new HttpHeaders ({
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization': 'Basic ' + btoa('constDigitalUpload' + ':' + '051277280567') 
  });
  constructor(private http: HttpClient,
    private route:Router) { }
  
    loginAuth(usuario: string, ingreso: string): Observable<any> {
      const params = new URLSearchParams();
      params.append('grant_type', 'password');
      params.append('username', usuario);
      params.append('password', ingreso);
     return this.http.post<any>(this.urlTOken, params.toString(), {headers: this.httpHeadersToken});
    }
  
    logear(usuario: string, pass: string): Observable<Persona> {
    return this.http.get<Persona>(this.baseEndPoint + '/logea/' + usuario +'/ingreso/' + pass).pipe(
      catchError(e => {
        this.route.navigate(['/login']);
        swal.fire('Error', "Fallo al intentar ingresar al sistema, volvler a intentar. El server manda el siguiente error : " 
                  + e.error.mensaje , 'error');
        return throwError(e);
      })
    );
  }
  
  getPersona(id:number):Observable<Persona>{
    return this.http.get<Persona>(`${this.baseEndPoint}/actuario/${id}`).pipe(
      catchError(e => {
        console.error(e.error.mensaje)
        swal.fire('Error al editar', e.error.mensaje,'error');
        return throwError(e);
      })
    )

  }
  
  cambiaIngreso(persona: Persona): Observable<any>{
    return this.http.put<any>(`${this.baseEndPoint}/cambiaIngreso/${persona.id}`,  persona,{headers: this.httpHeaders}).pipe(
      catchError(e => {
        if(e.status == 400){
          swal.fire(e.error.mensaje, e.error.error,'error');
          return throwError(e);
        } else {
          swal.fire(e.error.mensaje, e.error.error,'error');
          return throwError(e);
        }
      })
    )
  }

  restablecer(user: string): Observable<any>{
    let body= { usuario :user};
    return this.http.post<Persona>(`${this.baseEndPoint}/restablecer`, body, {headers: this.httpHeaders});   
  }

  buscarUsuario(user: string): Observable<any>{
    let body= { usuario :user};
    return this.http.post<Persona>(`${this.baseEndPoint}/buscarUsuario`, body, {headers: this.httpHeaders}); 
  }
}
